export const getNotificationSounds = () => ({
  egoraSound1: "/assets/sounds/notificationBeep.wav",
  egoraSound2: "/assets/sounds/mixkit-bell-notification-933.wav",
  egoraSound3: "/assets/sounds/Cute.mp3",
  egoraSound4: "/assets/sounds/Nice.mp3",
  egoraSound5: "/assets/sounds/Cute Magical Bell.mp3",
  egoraSound6: "/assets/sounds/loud.mp3",
  egoraSound7: "/assets/sounds/message.mp3",
  egoraSound8: "/assets/sounds/salesFault.mp3",
});
